module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iHMPL"))).then(() => parcelRequire('ikE14'));